import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

export default function JS_Introduction() {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">📖 JavaScript Introduction</h1>

      {/* Intro */}
      <p className="tutorial-intro">
        JavaScript (often abbreviated as JS) is the programming language of the
        Web. It enables interactive web pages and is an essential part of web
        applications. Alongside HTML and CSS, JavaScript is one of the core
        technologies of the World Wide Web.
      </p>

      {/* Key Points */}
      <div
        style={{
          background: "linear-gradient(135deg, #e0f2fe, #bae6fd)",
          padding: "1rem",
          paddingLeft: "35px",
          borderRadius: "12px",
          marginBottom: "2rem",
        }}
      >
        <h2 style={{ color: "#075985" }}>🔑 Key Points</h2>
        <ul className="tutorial-list-points">
          <li>JavaScript adds interactivity and behavior to web pages.</li>
          <li>
            It is a lightweight, interpreted, and versatile programming
            language.
          </li>
          <li>
            Runs on all modern browsers without needing installation or setup.
          </li>
          <li>Works alongside HTML (structure) and CSS (style).</li>
          <li>
            Widely used in frontend, backend (Node.js), and full-stack
            development.
          </li>
        </ul>
      </div>

      {/* Example */}
      <div className="tutorial-section">
        <h2 className="section-title">⚡ First JavaScript Example</h2>
        <p>
          You can add JavaScript directly inside an HTML document using the{" "}
          <code>{`<script>`}</code> tag.
        </p>

        <CodeCopyBlock
          code={`<!DOCTYPE html>
<html>
  <head>
    <title>JavaScript Example</title>
  </head>
  <body>
    <h2>Click the button to see JavaScript in action</h2>
    <button onclick="showMessage()">Click Me</button>

    <script>
      function showMessage() {
        alert("Hello from JavaScript!");
      }
    </script>
  </body>
</html>`}
        />

        <div style={{ marginTop: "1rem" }}>
          <button
            onClick={() => alert("Hello from JavaScript!")}
            style={{
              padding: "10px 20px",
              background: "#16a34a",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Run Example
          </button>
        </div>
      </div>

      {/* Where JavaScript is Used */}
      <div className="tutorial-section">
        <h2 className="section-title">🌍 Where is JavaScript Used?</h2>
        <ul className="tutorial-list-points">
          <li>Adding interactivity (sliders, forms, dropdowns).</li>
          <li>Dynamic content updates without reloading (AJAX, Fetch API).</li>
          <li>Validating form input in real time.</li>
          <li>Game development inside browsers.</li>
          <li>Backend development with Node.js.</li>
          <li>
            Mobile and desktop apps using frameworks like React Native &
            Electron.
          </li>
        </ul>
      </div>

      {/* Next Steps */}
      <div
        style={{
          background: "linear-gradient(135deg, #fef3c7, #fde68a)",
          padding: "1rem",
          paddingLeft: "35px",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2 style={{ color: "#92400e" }}>🚀 Next Steps</h2>
        <ul className="tutorial-list-points">
          <li>
            Learn about <b>JavaScript Syntax</b> (statements, variables, data
            types).
          </li>
          <li>
            Understand how to use <b>functions</b> and <b>operators</b>.
          </li>
          <li>
            Explore how JavaScript interacts with the <b>DOM</b>.
          </li>
          <li>Practice writing small scripts to build confidence.</li>
        </ul>
      </div>
    </div>
  );
}
